import React from 'react'
import { gecinaErrorColor, WHITE } from '../../theme'
import { Box, SxProps } from '@mui/material'

interface AcceptingProps {
	errorWhite?: boolean
	sx?: SxProps
}

const ErrorComponent: React.FC<AcceptingProps> = (
	{
		children,
		errorWhite = false,
		sx
	}
) => (
	<Box
		sx={[
			{
				color: errorWhite ? WHITE : gecinaErrorColor,
				fontSize: 12,
				width: '100%',
				textAlign: 'left'

			},
			...(Array.isArray(sx) ? sx : [sx])
		]}
	>
		{children}
	</Box>
)

export default ErrorComponent
